import type { ContentKeyDef } from "@/content/landing";
import { FUNNEL_COPY } from "@/content/funnel-copy";

export const S1B_SECTION = "screen.s1b";

/**
 * Age gate copy.
 *
 * The gate is ONE BIT — "18 or over, yes/no" — affirmed by a tick on the consent
 * block that sits ahead of the selfie. There is no date of birth field, so there
 * is no date-of-birth copy: nothing here asks for, explains or reassures about a
 * birth date, because none is collected.
 *
 * The threshold is CONFIG. The label and the decline both read it, so counsel
 * changing the number changes the wording with it.
 */
export const S1B_CONTENT: ContentKeyDef[] = [
  {
    key: "s1b.affirm.label",
    label: "Affirmation tick label ({{threshold}} = configured age)",
    group: "Affirmation",
    counsel: true,
    default: FUNNEL_COPY["s1b.affirm.label"],
  },
  {
    key: "s1b.affirm.hint",
    label: "Affirmation supporting line",
    group: "Affirmation",
    counsel: true,
    multiline: true,
    default: FUNNEL_COPY["s1b.affirm.hint"],
  },
  {
    key: "s1b.affirm.decline",
    label: "Decline link ({{threshold}} = configured age)",
    group: "Affirmation",
    counsel: true,
    default: FUNNEL_COPY["s1b.affirm.decline"],
  },
  // REFUSAL COPY — fixed wording. Terminal: no threshold echoed, no retry, no
  // edit-and-resubmit, no parent/guardian route, no support link, and no path
  // back into the funnel. The ONLY affordance is home.
  {
    key: "s1b.refusal.line1",
    label: "Refusal — first line",
    group: "Refusal",
    counsel: true,
    default: FUNNEL_COPY["s1b.refusal.line1"],
  },
  {
    key: "s1b.refusal.line2",
    label: "Refusal — second line",
    group: "Refusal",
    counsel: true,
    default: FUNNEL_COPY["s1b.refusal.line2"],
  },
  {
    key: "s1b.refusal.home",
    label: "Refusal — only affordance (home)",
    group: "Refusal",
    counsel: true,
    default: FUNNEL_COPY["s1b.refusal.home"],
  },
];

export const S1B_DEFAULTS: Record<string, string> = Object.fromEntries(
  S1B_CONTENT.map((k) => [k.key, k.default])
);
